import React, { useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function Contact() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
    return (
        <>
            <Navbar />
            <main className="bg-gray-100 min-h-52 py-12 px-4">
                <section className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-lg">
                    <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Contact Us</h1>
                    <p className="text-gray-600 mb-6 text-center">
                        We'd love to hear from you! If you have any questions or just want to get in touch, feel free to reach out. You can also connect with us on LinkedIn for updates and more information.
                    </p>
                    <div className="text-center space-y-4">
                        <p className="text-gray-600">
                            Connect with us on LinkedIn:
                            <a
                                href="https://www.linkedin.com/in/shahzaib-kesrani/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline ml-1"
                            >
                                Shahzaib Kesrani
                            </a>
                        </p>
                        <div className="border-t pt-4 mt-4">
                            <p className="text-gray-600 mb-2">Explore more developer tools:</p>
                            <div className="flex flex-wrap justify-center gap-2">
                                <a
                                    href="https://huntemoji.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:underline text-sm"
                                >
                                    Hunt Emoji
                                </a>
                                <span className="text-gray-400">•</span>
                                <a
                                    href="https://huntemoji.com/emoji"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:underline text-sm"
                                >
                                    Emoji Search
                                </a>
                                <span className="text-gray-400">•</span>
                                <a
                                    href="https://huntemoji.com/blog"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:underline text-sm"
                                >
                                    Emoji Blog
                                </a>
                                <span className="text-gray-400">•</span>
                                <a
                                    href="https://huntemoji.com/emoji-meanings"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:underline text-sm"
                                >
                                    Emoji Meanings
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}

export default Contact;
